import api from "api/axios";

const BASE = "/test";

export const testMasterApi = {
  list: (params) => api.get(BASE, { params }),
  importFile: (file) => {
    const body = new FormData();
    body.append("file", file);
    return api.post(`${BASE}/sheet/import`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  downloadFile: (kind, params) =>
    api.get(`${BASE}/sheet/${kind}`, { params, responseType: "blob" }),
};
